<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Button, Container, Loader, Text } from '@Shelly/shelly-design-system';
	import { get_oauth_code } from '../../../services/http';
	import { open_amazon_linking_android } from '../../../services/native_container_requests_android';
	import { open_amazon_linking_ios } from '../../../services/native_container_requests_ios';
	import { user_data } from 'src/stores/account/user';
	import { app, os } from 'src/stores/session/native-bridge';
	import { capFirstChar } from 'src/helpers/utilities';

	import { replace } from 'svelte-spa-router';

	import { navigateToUrl } from '../../Lists/list-helpers';
	import { loadingData } from 'src/stores/ui/loading-data';

	import TransitionWrapper from '../../Utility/TransitionWrapper.svelte';
	import { getLandingHref } from 'src/helpers/main_menu';
	import { currentUnitId } from 'src/stores/account/home';

	export let state, redirect_uri;

	const handleAllow = async () => {
		const unitId = $currentUnitId;
		const res = await get_oauth_code(
			$user_data.email,
			$user_data.password,
			'shelly-alexa-skill',
			unitId,
		);

		if (res.isok) {
			let redirect_url = `${redirect_uri}?code=${res.data.code}&state=${state}&source=app`;

			if ($app) {
				redirect_url = redirect_url + '&source=app';
				if ($os === 'IOS') {
					open_amazon_linking_ios(redirect_url, redirect_url);
				} else {
					open_amazon_linking_android(redirect_url, redirect_url);
				}
			} else {
				navigateToUrl(redirect_url, false);
			}
		}
		replace(getLandingHref());
	};

	const handleCancel = () => {
		const redirect_url = `${redirect_uri}?code=error=access_denied&state=${state}&error_description=The%20user%20denied%20the%20request.%20`;

		if ($app) {
			if ($os === 'IOS') {
				open_amazon_linking_ios(redirect_url, redirect_url);
			} else {
				open_amazon_linking_android(redirect_url, redirect_url);
			}
		} else {
			navigateToUrl(redirect_url);
		}
		replace(getLandingHref());
	};
</script>

<Container class="mb-s">
	{#if !$loadingData}
		<TransitionWrapper>
			<div class="d-flex flex-direction-column align-items-center">
				<Text element="h1" styleType="h1" class="mb-l text-center"
					>{$format('text_title_allow_alexa_integration', {
						default: 'Control your Shelly devices with your voice.',
					})}</Text
				>

				<img
					alt="app linking"
					class="mb-l max-width-full"
					src="images/app-linking/shelly-alexa-unlinked.svg"
				/>

				<Text class="mb-l text-center width-full"
					>{$format('text_description_allow_alexa_integration', {
						default:
							"Click 'Allow', to link your account with Alexa. You can unlink your account at any time, just disable Shelly Cloud skill from Amazon Alexa app or from the Shelly Smart Control app.",
					})}</Text
				>

				<Button class="width-md-auto mb-s" variant="primary" width="m" on:click={handleAllow}>
					{capFirstChar($format('button_allow', { default: 'Allow' }))}
				</Button>

				<Button class="width-md-auto mb-s" width="m" variant="secondary" on:click={handleCancel}>
					{$format('button_cancel', { default: 'Cancel' })}
				</Button>
			</div>
		</TransitionWrapper>
	{:else}
		<TransitionWrapper>
			<Loader class="mb-m" />
		</TransitionWrapper>
	{/if}
</Container>
